import { render } from "./vipBannerDialog.vue?vue&type=template&id=0bb1ab5d&scoped=true"
import script from "./vipBannerDialog.vue?vue&type=script&lang=js"
export * from "./vipBannerDialog.vue?vue&type=script&lang=js"

import "./vipBannerDialog.vue?vue&type=style&index=0&id=0bb1ab5d&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bb1ab5d"]])

export default __exports__